import RcDomainMap from "../../../common/RcDomainMap.js";
import EmployeeData from "./EmployeeData.js";

export default class EmployeeDataMap extends RcDomainMap {

  static MODEL_NAME = "EmployeeDataMap";

  constructor(domain, data) {
    super(domain, data, EmployeeDataMap.MODEL_NAME);
  }

  getEmployeeData(key) {
    var value = super.get(key);
    return new EmployeeData(this.domain, value);
  }

  find() {
    var keys = this.keys();
    var found = new EmployeeDataMap(this.domain, {});
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getEmployeeData(key);
      if (item.isNew()) {
        found.add(item);
      } else {
        var data = this.domain.employees().employeeData().findById(key);
        item = new EmployeeData(this.domain, data);
        if (!item.isNew()) {
          found.add(item);
        }
      }
    }
    return found;
  }

  populate() {
    var found = this.find();
    this.addAll(found);
    return this;
  }

  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      values.push(this.getEmployeeData(keys[index]));
    }
    return values;
  }

  // The row holding the latest value for what was recorded, or a new empty row
  // when the employee has nothing recorded for it yet. An employee should only
  // ever hold one row per key, but the newest wins if duplicates ever appear.
  forKey(key) {
    // Whether a row has been chosen yet is tracked on its own rather than through
    // isNew(): that answers true for any row which has not been saved, so it would
    // stay true all the way round the loop and simply keep the last row seen
    // instead of the most recently recorded one.
    var found = null;
    var list = this.list();
    for (var index = 0; index < list.length; index++) {
      var item = list[index];
      if (!item.isKey(key)) {
        continue;
      }
      if (found === null || item.recordedOn() > found.recordedOn()) {
        found = item;
      }
    }
    if (found === null) {
      return new EmployeeData(this.domain);
    }
    return found;
  }

  // Whether a value has been recorded for what was tracked. Tests the value
  // rather than whether the row has been persisted, so a row built in memory and
  // not yet saved still counts.
  hasKey(key) {
    return this.forKey(key).hasValue();
  }

  lastSignIn() {
    return this.forKey(EmployeeData.Values.Keys.LastSignIn);
  }

  copy() {
    var data = this._copy();
    return new EmployeeDataMap(this.domain, data);
  }
}
